export default function formatCents(cents) {
  if (!cents) return null;

  const price = cents / 100;
  return price.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
